import React from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './Video.css';

/** Landing hero video — [YouTube watch](https://youtu.be/9hQobvWGF4w) */
const YOUTUBE_VIDEO_ID = '9hQobvWGF4w';

function Video() {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);
  const title = t('videoTitle');

  const embedSrc = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?rel=0&modestbranding=1&playsinline=1`;

  return (
    <section className="video-section">
      <div className="container">
        <div className="section-header">
          <h2 className="video-title">{title}</h2>
        </div>
        <div className="video-wrapper">
          <iframe
            className="video-iframe"
            src={embedSrc}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </div>
    </section>
  );
}

export default Video;
